import React from "react"
import NavInformatii from "../../components/SideNavs/NavInformatii"
const Informatii = () => {
  return (
    <main className="pageContainer">
      <div style={{ margin: "0 auto", width: "80%" }}>
        <h1>Informații</h1>
        <NavInformatii />
      </div>
    </main>
  )
}

export default Informatii
